import { createRpcClientV2 } from 'rpc-client-utils';
import { createPortalsHttpClient, createPortalsFetchClient } from 'portals-platform-lib';
export const restClient = createPortalsHttpClient({
  prefix: '/_hcms/commerce-buyer-portal'
});
export const chirpClient = createRpcClientV2({
  hubHttpClient: restClient,
  fetchClient: createPortalsFetchClient(`/_hcms/commerce-buyer-portal`)
});